import { useSyncExternalStore } from 'react';

function subscribe(onStoreChange) {
  const el = document.documentElement;
  const obs = new MutationObserver(() => onStoreChange());
  obs.observe(el, { attributes: true, attributeFilter: ['data-theme'] });
  return () => obs.disconnect();
}

function getSnapshot() {
  return document.documentElement.getAttribute('data-theme') === 'dark';
}

function getServerSnapshot() {
  return false;
}

/** Соответствует `[data-theme="dark"]` на `document.documentElement` (STYLESYSTEM themes). */
export function useIsDarkTheme() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
